/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditSortCriteria {
    getFixupPrototypeFunction() { return RequestAuditSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditSortCriteria>): RequestAuditSortCriteria {
        let obj = Object.assign(new RequestAuditSortCriteria(), model);
        RequestAuditSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditSortCriteria>): RequestAuditSortCriteria {
        if (!model) return null;
        return RequestAuditSortCriteria.newInstance(<RequestAuditSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditSortCriteria) {
        if (!obj) return;

        models.RequestAuditSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditSortCriteria): boolean {
        Object.setPrototypeOf(obj, RequestAuditSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.RequestAuditSortColumn;

    ascending: boolean;

}
